module.exports = __webpack_public_path__ + "assets/media/day9.005ecc83.mp3";